export { default } from "./RegisterForm.jsx";
